import { api } from "./client";

export interface Endpoint {
  id: string;
  iccid: string;
  msisdn?: string;
  name?: string;
  status: string;
  tags?: string[];
  groupName?: string;
  [key: string]: unknown;
}

export interface EndpointDetail extends Endpoint {
  servingNetwork?: string;
  ipAddress?: string;
  location?: { lat: number; lng: number };
  [key: string]: unknown;
}

export interface SmsPayload {
  payloadText: string;
}

export const endpointsApi = {
  list: () =>
    api.get<{ data: Endpoint[] }>("/endpoints"),

  get: (id: string) =>
    api.get<{ data: EndpointDetail }>(`/endpoints/${id}`),

  getUsage: (id: string) =>
    api.get<{ data: unknown }>(`/billing/usage/${id}`),

  sendSms: (id: string, payload: SmsPayload) =>
    api.post<{ data: unknown }>(`/endpoints/${id}/sms`, payload),
};
